import React, { useState, useRef } from 'react'
import { Dropdown, Button, Popconfirm } from 'antd'
import { FileTextOutlined, DeleteOutlined, DownOutlined, ProfileOutlined } from '@ant-design/icons'
import './DropdownFile.scss' // 引入SCSS样式
import { downFocusSourceFileListApi } from 'api'
import { useDispatch } from 'react-redux'
import { BoundarySlice } from 'redux/reducers'
import { useTranslation } from 'react-i18next'

const DropdownFile = ({ fileList, buttonText, handleDelete, isFirstRender }) => {
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef(null)
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const Delete = id => {
        handleDelete(id)
        setOpen(true)
        isFirstRender.current = false
    }

    // 下载文件
    const uploadFile = (id, fileName) => {
        downFocusSourceFileListApi(id)
            .then(res => {
                const docData = res.data // 接口数据就是一个 blob 对象
                const reader = new FileReader() // 读取 blob 对象
                reader.readAsDataURL(docData) // 转成 base64 格式，也可以直接将 blob 对象放入 a href 中下载
                reader.onload = e => {
                    const a = document.createElement('a')
                    a.download = fileName
                    a.href = e.target.result
                    document.documentElement.appendChild(a)
                    a.click()
                    a.remove()
                }
            })
            .catch(err => {
                dispatch(BoundarySlice.actions.addError(err))
            })
    }

    // 渲染下拉内容
    const renderDropdownContent = () => (
        <div className='dropdown-content' onClick={e => e.stopPropagation()}>
            {fileList.map(file => (
                <div
                    key={file.id}
                    className='file-item'
                    onMouseEnter={e => {
                        e.currentTarget.classList.add('file-item-hover')
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.classList.remove('file-item-hover')
                    }}
                >
                    <div className='file-info'>
                        {file?.activityType === 'vpreport' ? (
                            <ProfileOutlined className='file-icon' />
                        ) : (
                            <FileTextOutlined className='file-icon' />
                        )}
                        <span className='file-name' onClick={() => uploadFile(file.fileId, file.fileName)}>
                            {file.fileName}
                        </span>
                    </div>
                    <Popconfirm
                        title={t('Users.tips4')}
                        onConfirm={() => Delete(file.id)}
                        okText={t('LogSettings.isReportOn')}
                        cancelText={t('LogSettings.isReportOff')}
                        placement='right'
                        getPopupContainer={() => dropdownRef.current}
                        onOpenChange={() => setOpen(true)}
                    >
                        <div className='delete-btn' onClick={e => e.stopPropagation()}>
                            <DeleteOutlined className='delete-icon' />
                        </div>
                    </Popconfirm>
                </div>
            ))}
        </div>
    )

    return (
        <div className='dropdown-container-file' ref={dropdownRef}>
            <Dropdown
                overlay={renderDropdownContent()}
                trigger={['click']}
                open={open}
                onOpenChange={status => {
                    if (!status) setOpen(false)
                }}
                placement='bottomLeft'
                getPopupContainer={() => dropdownRef.current}
                autoFocus={false}
            >
                <Button
                    className='main-button'
                    onClick={e => {
                        e.stopPropagation()
                        setOpen(!open)
                    }}
                >
                    {t('Vibrator.fileList')}
                    <DownOutlined className='down-icon' />
                </Button>
            </Dropdown>
        </div>
    )
}

export default DropdownFile
